import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { BehaviorSubject, Observable, of, throwError, catchError, concatMap, finalize, tap } from 'rxjs';

interface ErrorStatus {
  error: {
    errors?: string[];
    message?: string;
    status?: string;
  };
  status: number;
}
@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable();

  private _error = new BehaviorSubject<ErrorStatus>(undefined);
  public readonly error$ = this._error.asObservable();

  constructor(private notificationService: NotificationsService) {}
  showLoadingUntilCompleted<T>(observable$: Observable<T>) {
    return of(null).pipe(
      tap(() => {
        this.loading();
      }),
      concatMap(() => observable$),

      catchError((err: HttpErrorResponse) => {
        if (err.status == 401) {
          window.location.reload();
        }

        let defaultErrorMesssage =
          'Une erreur est survenue lors de la sauvegarde';

        defaultErrorMesssage = err?.error?.message
          ? err?.error?.message
          : defaultErrorMesssage;

        this.setErrors(err);

        this.loaded();
        !err?.error?.errors?.length &&
          this.notificationService.error('Erreur ', defaultErrorMesssage, {
            timeOut: 5000,
          });
        return throwError(err);
      }),
      tap(() => {
        this.setErrors(undefined);
      }),

      finalize(() => {
        this.loaded();
      }),
    );
  }
  loading() {
    this._loading.next(true);
  }

  loaded() {
    this._loading.next(false);
  }
  setErrors(error: ErrorStatus) {
    this._error.next(error);
  }
  getErrors() {
    return this._error.value;
  }
}
